import { useEffect, useRef, useState } from "react";
import { Phone, Search, BarChart3, Handshake } from "lucide-react";

// Parcours "Comment ça fonctionne ?" — 4 étapes reliées par une ligne qui se
// trace au scroll, nœuds numérotés (badge lime), arrivée en cascade + survol.
const ICONS = [Phone, Search, BarChart3, Handshake];
const DEFAULT_STEPS = [
  { title: "Vous nous contactez", text: "Vous demandez une étude ou déposez votre facture." },
  { title: "Nous analysons", text: "Nous étudions votre situation énergétique." },
  { title: "Nous comparons", text: "Nous identifions les solutions adaptées à vos besoins." },
  { title: "Nous vous accompagnons", text: "Nous vous guidons dans votre décision." },
];

export default function HowSteps({ steps = DEFAULT_STEPS, icons = ICONS }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setShown(true);
          io.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} className="relative">
      {/* ligne de liaison (desktop) */}
      <div className="pointer-events-none absolute left-[12.5%] right-[12.5%] top-10 hidden h-1 rounded-full bg-border md:block">
        <div className={`h-full rounded-full bg-primary transition-all duration-[1600ms] ease-out ${shown ? "w-full" : "w-0"}`} />
      </div>

      <div className="grid gap-12 md:grid-cols-4">
        {steps.map((s, i) => {
          const Icon = icons[i % icons.length];
          return (
            <div
              key={s.title}
              style={{ transitionDelay: `${i * 150}ms` }}
              className={`group relative flex flex-col items-center text-center transition-all duration-700 ease-out ${
                shown ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-8 scale-95"
              }`}
            >
              <div className="relative z-10 flex h-20 w-20 items-center justify-center rounded-3xl bg-primary text-white shadow-md transition-all duration-300 ease-out group-hover:-translate-y-1.5 group-hover:scale-110 group-hover:shadow-xl group-hover:shadow-primary/25 group-hover:ring-4 group-hover:ring-accent/40">
                <Icon className="h-8 w-8" strokeWidth={2.1} aria-hidden />
                <span className="absolute -right-2.5 -top-2.5 flex h-8 w-8 items-center justify-center rounded-full bg-accent font-display text-sm font-black text-accent-foreground ring-4 ring-secondary transition-transform duration-300 group-hover:scale-110">
                  {i + 1}
                </span>
              </div>
              <h3 className="mt-6 font-display text-xl font-bold text-primary transition-colors duration-300 group-hover:text-primary">
                {s.title}
              </h3>
              <p className="mt-2 max-w-[230px] text-sm leading-relaxed text-muted-foreground">{s.text}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
